/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  Filter,
  EditButton,
} from 'react-admin';

import Pagination from '../../components/Pagination';

import StatusSelectorInput from '../../components/StatusSelectorInput';

const CollectionsFilter = (props) => (
  <Filter {...props}>
    <StatusSelectorInput label="Status" source="status" alwaysOn />
  </Filter>
);

const CollectionList = (props) => (
  <Datagrid>
    <TextField source="title" sortable={false} />
    <TextField source="assets.total" sortable={false} />
    <TextField source="status" sortable={false} />
    <DateField source="createdAt" showTime sortable={false} />
    <DateField source="updatedAt" showTime sortable={false} />
    {props.hasEdit && <EditButton />}
  </Datagrid>
);

function CollectionsList(props) {
  return (
    <List
      {...props}
      title="Collections Listing"
      pagination={<Pagination />}
      perPage={100}
      filters={<CollectionsFilter />}
      exporter={false}
    >
      <CollectionList {...props} />
    </List>
  );
}

export default CollectionsList;
